export { View as CreditCardInput } from 'react-native'
